import React from "react";
import FeaturedImage from "../FeaturedImage";

function post(props) {
  const {
    post,
    postType,
    displayAuthor,
    displayExcerpt,
    displayDate,
    displayCategories,

    replaceSelected,
    theExcerpt,
  } = props;

  let featuredImage;
  let author;
  let readTime;
  let category;
  let type;

  if (post.hasOwnProperty("featured_image") && post.featured_image) {
    featuredImage = (
      <a href={post.link} className="post-card__image">
        <FeaturedImage
          imageSize={"related-card"}
          image={post.featured_image}
          srcset={post.featured_image}
        ></FeaturedImage>
      </a>
    );
  } else {
    featuredImage = (
      <a
        href={post.link}
        className="post-card__image"
        dangerouslySetInnerHTML={{ __html: post.acf_data.default_image }}
      ></a>
    );
  }

  if (post.hasOwnProperty("the_categories") && post.the_categories.length > 0) {
    if (displayCategories) {
      category = post.the_categories.map((category, index) => {
        if (category.taxonomy === "category") {
          let linkBefore = 0 !== index ? ', ' : '';
          return (
            <span>
              {linkBefore}
              <a
                href="#"
                className="post-card__category"
                key={category.id}
                onClick={(e) => {
                  e.preventDefault();
                  replaceSelected(category.id, category.taxonomy);
                }}
              >
                {category.name}
              </a>
            </span>
          );
        }
      });

      let isTypeSelected = false;
      type = post.the_categories.map((category, index) => {
        if (category.taxonomy === "p_type" && !isTypeSelected) {
          isTypeSelected = true;
          return (
            <a
              href="#"
              className="post-card__type"
              key={category.id}
              onClick={(e) => {
                e.preventDefault();
                replaceSelected(category.id, category.taxonomy);
              }}
            >
              {category.name}
            </a>
          );
        }
      });
    }
  }

  if (post.acf_data.read_time) {
    readTime = (
      <span className="post-card__read-time">{post.acf_data.read_time}</span>
    );
  }

  if (post.the_author && displayAuthor) {
    author = <p className="post-card__author-name">By {post.the_author}</p>;

    if (post.acf_data.author) {
      author = (
        <div className="post-card__author">
          <a
            target="_blank"
            href={post.acf_data.author.link}
            className="post-card__author-link"
          >
            <div
              className="post-card__author-avatar"
              dangerouslySetInnerHTML={{ __html: post.acf_data.author.avatar }}
            ></div>
            <p className="post-card__author-name">By {post.the_author}</p>
          </a>
        </div>
      );
    }
  }

  return (
    <article id={`${postType}-${post.id}`} className="post-card">
      {featuredImage}

      {type}

      <div className="post-card__content">
        <div className="post-card__head">
          {category}
          {readTime}
        </div>

        <h3 className="post-card__title">
          <a
            href={post.link}
            dangerouslySetInnerHTML={{ __html: post.title.rendered }}
          ></a>
        </h3>

        {author}
      </div>
    </article>
  );
}

export default post;
